<template>
  <v-card :loading="isLoading">
    <v-card-title>
      <span class="text-lg-h5">
        Configuration for
        <span class="font-weight-bold ml-1">{{ formTitle }}</span>
      </span>
    </v-card-title>

    <v-card-text>
      <v-container>
        <v-row>
          <v-col
            v-for="input in mappedVars"
            :key="input.name"
            cols="12"
            md="12"
          >
            <!-- Non-JSON field -->
            <v-text-field
              v-if="input.type !== 'json'"
              v-model="formData[input.name]"
              :type="input.type"
              :label="input.name"
              :disabled="isLocked"
              required
            />

            <!-- JSON field -->
            <JsonTextField
              v-else
              v-model="formData[input.name]"
              :disabled="isLocked"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>

    <v-card-actions>
      <v-spacer />

      <v-btn
        color="blue darken-1"
        text
        @click="onCancel"
      >
        Cancel
      </v-btn>
      <v-btn
        color="blue darken-1"
        text
        :disabled="isLocked"
        @click="onSubmit"
      >
        Save
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import JsonTextField from '../../ScoringElement/JsonTextField.vue';

// NOTE: ADD UNIT TEST FOR THIS COMPONENT
export default {
  name: 'ScoringModelSequenceElementForm',

  components: {
    JsonTextField,
  },

  props: {
    customVars: {
      type: Object,
      default: () => {},
    },
    formTitle: {
      type: String,
      default: '',
    },
    isLocked: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      formData: {},
    };
  },

  computed: {
    /**
     * Maps the customVars array to an array of objects
     * with shape { name, type } so the template can loop over them.
     */
    mappedVars() {
      return this.formattedCustomVars.map(([name, { type }]) => ({
        name,
        type,
      }));
    },

    formattedCustomVars() {
      return Object.entries(this.customVars || {});
    },
  },

  watch: {
    /**
     * Whenever customVars changes, re-generate formData.
     * This ensures we're always in sync with the parent.
     */
    customVars: {
      immediate: true,
      handler() {
        this.formData = this.createFormData(this.formattedCustomVars);
      },
    },
  },

  methods: {
    /**
     * Convert the incoming array into a formData object:
     * { [varName]: varValue, ... }
     */
    createFormData(vars) {
      return vars.reduce((acc, [name, { value }]) => {
        acc[name] = value;
        return acc;
      }, {});
    },

    onCancel() {
      this.$emit('cancel');
    },

    onSubmit() {
      this.$emit('submit', this.formData);
    },
  },
};
</script>
